export enum BannerTypeEnum {
  Active,
  Draft,
  Upcoming,
}
